module.exports = __webpack_public_path__ + "media/images/icon__questionmark--rb-light-gray-3bcaf37bc0f2be0185fb4c9345ed8a16.png";